import React from "react";
import { IconBaseProps, IconType } from "react-icons/lib";
import { HasProperty } from "../../Helpers/helper";
import loadable from "@loadable/component";
import { GetIconFamilyValue, IconFamilyEnumKeys } from "../../Enums/IconFamilyEnum";
import { Skeleton } from "@mui/material";
import { NonceUUID } from "../../configurations/CSP/Nonce";

type loadableIconProps = {} & IconBaseProps
type DynamicIconPropsType = {
    Name: string;
    Family: IconFamilyEnumKeys;
    className?: string,
    propsIcon?: IconBaseProps
}

const DynamicIcon = ({ Family, Name, propsIcon, className }: DynamicIconPropsType): JSX.Element => {

    if (!Name || Name == "")
        throw new Error("Name of icon could not be null or empty.");

    if (Family == null)
        throw new Error("Family of icon could not be null");

    const familyName: string = GetIconFamilyValue(Family),
        Icon = loadable<loadableIconProps, JSX.Element>(() => import(`react-icons/${familyName}/index.js`), {
            cacheKey: () => Name,
            fallback: <Skeleton animation="pulse" nonce={NonceUUID} />,
            resolveComponent: (icons) => {
                const name: string = HasProperty(icons, Name) ? Name : Object.keys(icons)[0],
                    icon = icons[name as keyof JSX.Element] as IconType;
                return icon;
            },
        });

    return (<Icon className={className} {...propsIcon} />);
}


export default DynamicIcon